<template>
    <div>
        <figure class="is-3by2">
            <img :src="staticMapURL" style="object-fit: cover" />
        </figure>
    </div>
</template>

<script>
import { staticMap } from '@/services/API';
export default {
    props: {
        location: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        staticMapURL() {
            return staticMap(
                this.location.longitude,
                this.location.latitude,
                this.location.zoomLevel
            );
        },
    },
};
</script>

<style scoped></style>
